var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showMarketingPopupMessage)?_c('marketing-message',{attrs:{"marketing-message":_vm.marketingMessage}}):_c('email-login-setup-reminder-message',{attrs:{"routes":_vm.routes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }